(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  function initMissNewsletterFeedback() {
    const form = document.getElementById('ContactFooter');
    if (!form || form.dataset.feedbackReady) return;
    const status = form.querySelector('#ContactFooter-status');
    const button = form.querySelector('button[type="submit"]');
    if (!status || !button) return;
    form.dataset.feedbackReady = 'true';
    let timer;
    const reset = () => {
      clearTimeout(timer);
      button.removeAttribute('aria-busy');
      status.hidden = true;
      status.textContent = '';
    };
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      clearTimeout(timer);
      status.textContent = status.dataset.pending;
      status.hidden = false;
      button.setAttribute('aria-busy', 'true');
      timer = setTimeout(() => {
        button.removeAttribute('aria-busy');
        status.textContent = status.dataset.delayed;
      }, 15000);
    }, true);
    form.addEventListener('invalid', reset, true);
    window.addEventListener('pageshow', (event) => { if (event.persisted) reset(); });
    window.addEventListener('pagehide', () => clearTimeout(timer));
  }
  initMissNewsletterFeedback();
  document.addEventListener('DOMContentLoaded', initMissNewsletterFeedback);
  document.addEventListener('shopify:section:load', initMissNewsletterFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-care-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-care-guide-download]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (window.Shopify?.designMode) return;
    try {
      const published = window.Shopify?.analytics?.publish('miss_earrings:care_guide_download_requested', {
        guide_id: 'aftercare',
        file_name: 'Miss-Earrings-guia-cuidados.png'
      });
      if (published?.catch) published.catch(() => {});
    } catch {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-contact-page"]) return;
  try {
    
(function () {
  function init(form) {
    if (form.dataset.contactReady) return;
    form.dataset.contactReady = 'true';
    var status = form.querySelector('[data-contact-status]');
    var fields = form.querySelector('[data-contact-fields]');
    var button = form.querySelector('button[type="submit"]');
    var requestId = form.querySelector('[name="_request_id"]');
    var sending = false;
    form.addEventListener('input', function () { if (!sending) requestId.value = ''; });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (sending) return;
      if (!form.reportValidity()) return;
      sending = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.setAttribute('role', 'status');
      status.classList.remove('mec-callback__status--error');
      status.textContent = form.dataset.sending;
      try {
        if (!requestId.value) requestId.value = crypto.randomUUID();
        var response = await fetch(form.action, { signal: AbortSignal.timeout(20000), method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }, body: new URLSearchParams(new FormData(form)).toString() });
        var data = await response.json();
        if (!response.ok || !data.ok) { var rejection = new Error(data.message || form.dataset.error); rejection.name = 'ContactSubmissionError'; throw rejection; }
        fields.hidden = true;
        status.textContent = form.dataset.success;
        status.focus({ preventScroll: true });
      } catch (error) {
        status.classList.add('mec-callback__status--error');
        status.setAttribute('role', 'alert');
        status.textContent = error.name === 'ContactSubmissionError' ? error.message : form.dataset.error;
        status.focus({ preventScroll: true });
      } finally {
        sending = false;
        button.disabled = false;
        form.setAttribute('aria-busy', 'false');
      }
    });
  }
  function scan() { document.querySelectorAll('[data-mec-information-form]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-professional-system"] && !Shopify.designMode) return;
  try {
    
  const openProfessionalSystem = () => {
    if (window.location.hash !== '#sistema') return;
    const details = document.querySelector('.miss-pro-system__details');
    if (!details) return;
    details.open = true;
    requestAnimationFrame(() => details.scrollIntoView({ block: 'start' }));
  };
  window.addEventListener('hashchange', openProfessionalSystem);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openProfessionalSystem, { once: true });
  else openProfessionalSystem();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-retail-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('miss-retail-autoplay')) {
    customElements.define('miss-retail-autoplay', class extends HTMLElement {
      connectedCallback() {
        if (this.timer) return;
        const slider = this.querySelector('mev-collection-slider');
        const track = this.querySelector('[data-mev-track]');
        const button = this.querySelector('[data-mev-playback]');
        if (!slider || !track) return;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let paused = motion.matches;
        let inView = false;
        let hovering = false;
        this.events = new AbortController();
        const options = {signal: this.events.signal};
        const update = () => {
          if (button) {
            button.dataset.paused = String(paused);
            button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
          }
          this.dataset.autoplay = paused ? 'paused' : 'playing';
          const status = this.querySelector('[data-mev-status]');
          if (status) status.setAttribute('aria-live', paused ? 'polite' : 'off');
        };
        const stop = (event) => { if (event.target instanceof Node && button?.contains(event.target)) return; paused = true; update(); };
        if (button) {
          button.hidden = false;
          button.addEventListener('click', () => { paused = !paused; update(); }, options);
        }
        slider.addEventListener('mouseenter', () => { hovering = true; }, options);
        slider.addEventListener('mouseleave', () => { hovering = false; }, options);
        slider.addEventListener('pointerdown', stop, options);
        slider.addEventListener('focusin', stop, options);
        slider.addEventListener('keydown', stop, options);
        motion.addEventListener('change', stop, options);
        this.observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
        }, {threshold: 0.35});
        this.observer.observe(slider);
        this.timer = setInterval(() => {
          if (paused || hovering || !inView || document.hidden || (slider.contains(document.activeElement) && document.activeElement !== button)) return;
          const first = track.querySelector('[data-mev-item]');
          if (!first) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 3) {
            track.scrollTo({left: 0, behavior: 'instant'});
          } else {
            track.scrollBy({left: first.getBoundingClientRect().width + gap, behavior: motion.matches ? 'instant' : 'smooth'});
          }
        }, 4000);
        update();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.timer = null;
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miss-vibrant-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miss-home-slider')) {
  customElements.define('miss-home-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const opts = {signal: this.abort.signal};
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.index = 0;
      this.english = document.documentElement.lang.startsWith('en');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
      this.delay = Math.max(4000, Number(this.dataset.delay) || 7000);
      this.controls = this.querySelector('.mhs-controls');
      if (this.slides.length < 2) return;
      this.controls.hidden = false;
      this.pauseButton = this.querySelector('[data-hero-pause]');
      this.slides.forEach((s, i) => {s.setAttribute('role', 'group');s.setAttribute('aria-roledescription', this.english ? 'slide' : 'diapositiva');s.setAttribute('aria-label', `${i + 1} ${this.english ? "of" : "de"} ${this.slides.length}`);});
      this.querySelector('[data-hero-prev]').addEventListener('click', () => this.show(this.index - 1), opts);
      this.querySelector('[data-hero-next]').addEventListener('click', () => this.show(this.index + 1), opts);
      this.pauseButton.addEventListener('click', () => {this.paused = !this.paused;this.updatePause();this.schedule();}, opts);
      this.addEventListener('pointerenter', e => {if(e.pointerType === 'mouse'){this.hovered = true;this.schedule();}}, opts);
      this.addEventListener('pointerleave', () => {this.hovered = false;this.schedule();}, opts);
      this.addEventListener('focusin', () => {this.focused = true;this.schedule();}, opts);
      this.addEventListener('focusout', e => {if(!this.contains(e.relatedTarget)){this.focused = false;this.schedule();}}, opts);
      this.addEventListener('keydown', e => {if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){e.preventDefault();this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1));}}, opts);
      this.querySelector('.mhs-track').addEventListener('touchstart', e => {this.touch = {x:e.touches[0].clientX,y:e.touches[0].clientY};}, {...opts,passive:true});
      this.querySelector('.mhs-track').addEventListener('touchend', e => {if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch.x,dy=e.changedTouches[0].clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.3)this.show(this.index+(dx<0?1:-1));}, {...opts,passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.updatePause();this.schedule();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((s,i) => {const active=i===this.index;s.classList.toggle('is-active',active);s.inert=!active;s.setAttribute('aria-hidden',String(!active));});
      this.schedule();
    }
    updatePause() {this.pauseButton.textContent=this.paused?'▷':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.english?(this.paused?'Resume slideshow':'Pause slideshow'):(this.paused?'Reanudar carrusel':'Pausar carrusel'));}
    schedule() {clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>this.show(this.index+1),this.delay);}
    disconnectedCallback() {clearTimeout(this.timer);this.abort?.abort();this.abort=null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
